// extracted by mini-css-extract-plugin
export default {"groupsWrapper":"styles_groupsWrapper__z0CIu","emptyDataGreyText":"styles_emptyDataGreyText__vrqIV","antBtn":"styles_antBtn__qYe85","btnContainer":"styles_btnContainer__oYA8E"};